/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type CashbackShow_cashback$ref = any;
export type UpdateCashbackStateInput = {|
  clientMutationId?: ?string,
  id: string,
  quarantinedReason?: ?string,
  state: string,
|};
export type updateCashbackStateMutationVariables = {|
  input: UpdateCashbackStateInput
|};
export type updateCashbackStateMutationResponse = {|
  +updateCashbackState: ?{|
    +cashback: ?{|
      +id: string,
      +date: any,
      +name: string,
      +rate: ?string,
      +amount: number,
      +source: string,
      +pended: boolean,
      +plaidTransactionId: ?string,
      +transactionAmount: ?number,
      +fastCashId: ?string,
      +state: ?string,
      +quarantinedReason: ?string,
      +availableStates: ?$ReadOnlyArray<string>,
      +userAuth0Id: ?string,
      +$fragmentRefs: CashbackShow_cashback$ref,
    |},
    +errorMessage: ?string,
    +errors: ?$ReadOnlyArray<{|
      +key: string,
      +messages: $ReadOnlyArray<string>,
    |}>,
  |}
|};
export type updateCashbackStateMutation = {|
  variables: updateCashbackStateMutationVariables,
  response: updateCashbackStateMutationResponse,
|};
*/


/*
mutation updateCashbackStateMutation(
  $input: UpdateCashbackStateInput!
) {
  updateCashbackState(input: $input) {
    cashback {
      id
      date
      name
      rate
      amount
      source
      pended
      plaidTransactionId
      transactionAmount
      fastCashId
      state
      quarantinedReason
      availableStates
      userAuth0Id
      ...CashbackShow_cashback
    }
    errorMessage
    errors {
      key
      messages
    }
  }
}

fragment CashbackShow_cashback on Cashback {
  id
  date
  name
  rate
  amount
  source
  pended
  plaidTransactionId
  transactionAmount
  fastCashId
  state
  quarantinedReason
  availableStates
  userAuth0Id
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateCashbackStateInput!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "date",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rate",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "source",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pended",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "plaidTransactionId",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "transactionAmount",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fastCashId",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "quarantinedReason",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "availableStates",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userAuth0Id",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errorMessage",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "ValidationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "key",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "messages",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateCashbackStateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateCashbackStatePayload",
        "kind": "LinkedField",
        "name": "updateCashbackState",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Cashback",
            "kind": "LinkedField",
            "name": "cashback",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "CashbackShow_cashback"
              }
            ],
            "storageKey": null
          },
          (v16/*: any*/),
          (v17/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "RootMutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateCashbackStateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateCashbackStatePayload",
        "kind": "LinkedField",
        "name": "updateCashbackState",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Cashback",
            "kind": "LinkedField",
            "name": "cashback",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/)
            ],
            "storageKey": null
          },
          (v16/*: any*/),
          (v17/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "updateCashbackStateMutation",
    "operationKind": "mutation",
    "text": "mutation updateCashbackStateMutation(\n  $input: UpdateCashbackStateInput!\n) {\n  updateCashbackState(input: $input) {\n    cashback {\n      id\n      date\n      name\n      rate\n      amount\n      source\n      pended\n      plaidTransactionId\n      transactionAmount\n      fastCashId\n      state\n      quarantinedReason\n      availableStates\n      userAuth0Id\n      ...CashbackShow_cashback\n    }\n    errorMessage\n    errors {\n      key\n      messages\n    }\n  }\n}\n\nfragment CashbackShow_cashback on Cashback {\n  id\n  date\n  name\n  rate\n  amount\n  source\n  pended\n  plaidTransactionId\n  transactionAmount\n  fastCashId\n  state\n  quarantinedReason\n  availableStates\n  userAuth0Id\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '66932daf450c7dbadda7c5fa5140c8c5';

module.exports = node;
